import { type ReactElement } from "react";
import { SipocWidget, type SipocWidgetProps } from "./Component.js";

export type SipocCardProps = Omit<SipocWidgetProps, "size">;

/**
 * SipocCard — the SIPOC body the VSM canvas card mounts (`VsmArtifactWidgetBody`
 * resolves it through the `CardComponent` seam). It is the SAME editable board
 * as the expanded editor, at the `lg` scale: the artifact card is 2000×920 flow
 * units and is read at 45–80% canvas zoom, so panel-scale type is unreadable
 * there and a read-only preview forced every edit through the expand button.
 * Steps are edited in place, and the board scrolls inside the card once the
 * steps outgrow its height.
 */
export function SipocCard(props: SipocCardProps): ReactElement {
  return <SipocWidget {...props} size="lg" />;
}
